import { render, staticRenderFns } from "./AgendaListRoute.vue?vue&type=template&id=e1574ea8"
import script from "./AgendaListRoute.vue?vue&type=script&lang=js"
export * from "./AgendaListRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports